import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/standard-button';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	issuesLength: number;
	isShowMoreExpanded: boolean;
	onExpand: () => void;
};

const ShowMoreExpander = ({ issuesLength, isShowMoreExpanded, onExpand }: Props) => {
	const { formatMessage } = useIntl();
	const handleExpand = (event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		onExpand();
		fireUIAnalytics(analyticsEvent, 'showMoreRelatedIssues', {
			issuesLength,
		});
	};

	const renderShowMoreIssuesButton = () => (
		<ButtonWrapper>
			<Button
				appearance="link"
				onClick={handleExpand}
				interactionName="auto-generated.jira-smart-related-issues-panel.ui.issue-line-card-group.show-more.button"
			>
				{formatMessage(messages.show)}
			</Button>
		</ButtonWrapper>
	);

	return isShowMoreExpanded ? null : renderShowMoreIssuesButton();
};

export default ShowMoreExpander;

// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({
	marginTop: token('space.100', '8px'),
	marginRight: '0px',
	marginBottom: token('space.100', '8px'),
	marginLeft: '0px',
});
